window.theme = window.theme || {};
window.slate = window.slate || {};

// Shopify CDN resizes via a width param on both cdn.shopify.com and /cdn/shop URLs.
theme.sizedImageUrl = function(src, width) {
  return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
};

// Same widths and cap as the main image's srcset/sizes in snippets/product-images.liquid.
theme.productImageSrcsetWidths = [480, 720, 1024, 1440];
theme.productImageMaxSlot = 700;

// Variant selection: watches option inputs in cart/add forms, syncs the master select
// and fires events when the variant's price, image or SKU changes.

slate.Variants = (function() {
  function Variants(options) {
    this.container = options.container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    var self = this;
    this._onSelectChangeHandler = this._onSelectChange.bind(this);
    this.container.querySelectorAll(this.singleOptionSelector).forEach(function(el) {
      el.addEventListener('change', self._onSelectChangeHandler);
    });
  }

  Variants.prototype = Object.assign({}, Variants.prototype, {
    // Selected option values from the add-to-cart form.
    _getCurrentOptions: function() {
      var elements = this.container.querySelectorAll(this.singleOptionSelector);
      var currentOptions = Array.prototype.map.call(elements, function(element) {
        var type = element.type;
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if (element.checked) {
            currentOption.value = element.value;
            currentOption.index = element.dataset.index;

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = element.value;
          currentOption.index = element.dataset.index;

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = currentOptions.filter(Boolean);

      return currentOptions;
    },

    // Variant matching the selected values, or undefined.
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = variants.find(function(variant) {
        return selectedValues.every(function(values) {
          return variant[values.index] === values.value;
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.container.dispatchEvent(
        new CustomEvent('variantChange', { detail: { variant: variant } })
      );

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantImageChange', { detail: { variant: variant } })
      );
    },

    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantPriceChange', { detail: { variant: variant } })
      );
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantSKUChange', { detail: { variant: variant } })
      );
    },

    // Put ?variant= in the URL so the selection can be linked.
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    _updateMasterSelect: function(variant) {
      var masterSelect = this.container.querySelector(this.originalSelectorId);
      if (masterSelect) masterSelect.value = variant.id;
    },

    unbind: function() {
      var self = this;
      this.container.querySelectorAll(this.singleOptionSelector).forEach(function(el) {
        el.removeEventListener('change', self._onSelectChangeHandler);
      });
    }
  });

  return Variants;
})();

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.modal = document.getElementById(id);

    if (!this.modal) {
      return;
    }

    this.body = document.body;
    this.config = Object.assign({}, defaults, options);

    this.modalIsOpen = false;
    this.focusOnOpen = this.config.focusOnOpen
      ? document.querySelector(this.config.focusOnOpen)
      : this.modal;

    this._onKeyupHandler = this._onKeyup.bind(this);

    this.init();
  };

  Modal.prototype.init = function() {
    var self = this;

    document.querySelectorAll(this.config.open).forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', self.open.bind(self));
    });

    this.modal.querySelectorAll(this.config.close).forEach(function(btn) {
      btn.addEventListener('click', self.close.bind(self));
    });
  };

  Modal.prototype.open = function(evt) {
    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    }

    // Without this, the click bubbles up to the page and closes the modal again.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget;
    }

    theme.prepareTransition(this.modal);
    this.modal.classList.add(this.config.openClass);
    this.body.classList.add(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      container: this.modal,
      namespace: 'modal_focus',
      elementToFocus: this.focusOnOpen
    });

    if (this.activeSource && this.activeSource.getAttribute('aria-expanded') !== null) {
      this.activeSource.setAttribute('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    if (document.activeElement) document.activeElement.blur();

    theme.prepareTransition(this.modal);
    this.modal.classList.remove(this.config.openClass);
    this.body.classList.remove(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      container: this.modal,
      namespace: 'modal_focus'
    });

    if (this.activeSource && this.activeSource.getAttribute('aria-expanded') !== null) {
      this.activeSource.setAttribute('aria-expanded', 'false');
      this.activeSource.focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.body.addEventListener('keyup', this._onKeyupHandler);
  };

  Modal.prototype._onKeyup = function(evt) {
    if (evt.keyCode === 27) {
      this.close();
    }
  };

  Modal.prototype.unbindEvents = function() {
    this.body.removeEventListener('keyup', this._onKeyupHandler);
  };

  return Modal;
})();

window.AjaxCart = (function() {
  var cart = function(form) {
    this.form = form;

    this._onSubmitHandler = this.addItemFromForm.bind(this);

    if (this.form) {
      this.form.addEventListener('submit', this._onSubmitHandler);
    }
  };

  cart.prototype.addItemFromForm = function(evt) {
    evt.preventDefault();

    // One add at a time: a repeated submit (eg. held Enter, which the spinner overlay doesn't block)
    // is ignored until the current request settles, success or failure.
    if (this._adding) return;
    this._adding = true;

    var self = this;
    // FormData (rather than a urlencoded serialize) so any file inputs in
    // the form -- eg. the crossgrade/education proof upload -- are actually
    // included in the request instead of being silently dropped.
    var formData = new FormData(this.form);

    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok) {
            var error = new Error(data.message || 'Add to cart request failed');
            error.data = data;
            throw error;
          }
          return data;
        });
      })
      .then(function(lineItem) {
        // add.js returns only the added line; fetch the cart so the header badge is right. The item
        // is already in the cart, so a failed refresh only skips the badge update: still a success.
        return fetch(theme.routes.cart + '.js')
          .then(function(res) {
            if (!res.ok) throw new Error('Cart refresh failed with status ' + res.status);
            return res.json();
          })
          .then(function(cart) {
            if (!cart || !Array.isArray(cart.items)) throw new Error('Cart refresh returned no cart');
            if (typeof theme.updateCartTotals === 'function') {
              theme.updateCartTotals(cart);
            }
          })
          .catch(function(err) {
            console.error('[AjaxCart] Item added, but the cart badge could not be refreshed:', err);
          })
          .then(function() {
            self.success(lineItem);
          });
      }, function(err) {
        self.error(err);
      })
      .then(function() {
        self._adding = false;
      });
  };

  cart.prototype.success = function() {
    // The submit button's onclick="spinner()" shows the overlay; AJAX add-to-cart must hide it.
    spinner(false);
    theme.Notify.open('success', false, true);
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function(err) {
    spinner(false);
    var data = err && err.data;

    var message = data && (data.description || data.message);
    theme.Notify.open('error', message || 'Something went wrong. Please try again.', true);
  };

  return cart;
})();

theme.Product = (function() {
  var defaults = {
    ajaxCart: true
  };

  function debounce(delay, fn) {
    var timer;
    return function() {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function() {
        fn.apply(null, args);
      }, delay);
    };
  }

  // Prev/next buttons that page a scroll-snap strip by its width, disabled at each end.
  // Used by the thumbnails and Available Bundles; does nothing if the strip doesn't overflow.
  function buildScrollArrows(wrapperEl, ariaLabelNoun) {
    if (!wrapperEl || wrapperEl.scrollWidth <= wrapperEl.clientWidth + 1) {
      return null;
    }

    var wrapEl = document.createElement('div');
    wrapEl.className = 'scroll-arrows-wrap';
    wrapperEl.parentNode.insertBefore(wrapEl, wrapperEl);
    wrapEl.appendChild(wrapperEl);

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'scroll-arrow scroll-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous ' + ariaLabelNoun);

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'scroll-arrow scroll-arrow--next';
    nextBtn.setAttribute('aria-label', 'Next ' + ariaLabelNoun);

    prevBtn.addEventListener('click', function() {
      wrapperEl.scrollBy({ left: -wrapperEl.clientWidth, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function() {
      wrapperEl.scrollBy({ left: wrapperEl.clientWidth, behavior: 'smooth' });
    });

    wrapEl.insertBefore(prevBtn, wrapperEl);
    wrapEl.appendChild(nextBtn);

    function updateState() {
      prevBtn.disabled = wrapperEl.scrollLeft <= 0;
      var maxScroll = wrapperEl.scrollWidth - wrapperEl.clientWidth;
      nextBtn.disabled = wrapperEl.scrollLeft >= maxScroll - 1;
    }
    updateState();

    var onScroll = debounce(100, updateState);
    wrapperEl.addEventListener('scroll', onScroll, { passive: true });

    // Callers that track their own listeners for cleanup (e.g. onUnload)
    // need this reference to remove it later.
    return { prevBtn: prevBtn, nextBtn: nextBtn, onScroll: onScroll };
  }

  // Hidden proof fields are also disabled, so FormData(form) never submits a file chosen for another edition.
  function toggleDisplay(selector, shouldShow) {
    var el = document.querySelector(selector);
    if (!el) return;
    el.style.display = shouldShow ? '' : 'none';
    el.querySelectorAll('input, select, textarea').forEach(function(field) {
      field.disabled = !shouldShow;
    });
  }

  function Product(container) {
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');

    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      modal: 'ProductModal',
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.variant-sku',
      productFeaturedImage: '#product-featured-image-' + sectionId,
      productImageWrap: '#product-image-link-' + sectionId,
      productThumbAllImages: '.product-thumbnail',
      productThumbImages: '.product-thumbnail-' + sectionId,
      productThumbs: '#product-thumbnails-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId
    };

    this.settings = Object.assign({}, defaults, {
      sectionId: sectionId,
      ajaxCart: container.dataset.ajax === 'true',
      enableHistoryState: container.dataset.enableHistoryState === 'true',
      namespace: '.product-' + sectionId
    });

    var productJsonEl = document.getElementById('ProductJson-' + sectionId);

    // Stop parsing if we don't have the product json script tag
    if (!productJsonEl || !productJsonEl.innerHTML) {
      return;
    }

    this.productSingleObject = JSON.parse(productJsonEl.innerHTML);

    this.init();
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    init: function() {
      this._initVariants();
      this._productZoomImage();
      this._productThumbSwitch();
      this._productThumbnailSlider();
      this._bundlesSlider();
      this._buyBar();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart(document.getElementById('AddToCartForm'));
      }
    },

    // Shows the bar while the real add-to-cart button is scrolled above the screen; the bar's
    // button clicks the real one, and its price/label are copied from the buy box when it appears.
    _buyBar: function() {
      var bar = document.getElementById('ProductBuyBar-' + this.settings.sectionId);
      var button = document.querySelector(this.selectors.addToCart);
      var price = document.querySelector(this.selectors.productPrice);
      if (!bar || !button || !('IntersectionObserver' in window)) return;

      var barButton = bar.querySelector('.product-buy-bar__btn');
      var barPrice = bar.querySelector('.product-buy-bar__price');

      barButton.addEventListener('click', function() {
        button.click();
      });

      new IntersectionObserver(function(entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (show) {
          barPrice.textContent = price ? price.textContent.trim() : '';
          barButton.innerHTML = button.innerHTML;
          barButton.disabled = button.disabled;
        }
        bar.classList.toggle('is-visible', show);
        // Only the visible bar is exposed to assistive tech and the tab order (it's never shown on desktop).
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        barButton.tabIndex = show ? 0 : -1;
      }).observe(button);
    },

    _initVariants: function() {
      var options = {
        container: this.container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      this.variants = new slate.Variants(options);

      // slate.Variants dispatches CustomEvents with the variant on
      // evt.detail -- unwrap here so the handlers below can share their
      // {variant} shape with the direct calls just below.
      var self = this;
      this._onVariantChangeHandler = function(evt) {
        self._updateAddToCartBtn(evt.detail);
        self._updateDelivery(evt.detail);
      };
      this._onVariantPriceChangeHandler = function(evt) { self._updatePrice(evt.detail); };
      this._onVariantSKUChangeHandler = function(evt) { self._updateSKU(evt.detail); };
      this._onVariantImageChangeHandler = function(evt) { self._updateImages(evt.detail); };

      this.container.addEventListener('variantChange', this._onVariantChangeHandler);
      this.container.addEventListener('variantPriceChange', this._onVariantPriceChangeHandler);
      this.container.addEventListener('variantSKUChange', this._onVariantSKUChangeHandler);
      this.container.addEventListener('variantImageChange', this._onVariantImageChangeHandler);

      // Run the variant handlers once on load; otherwise they only fire on a user 'change'.
      if (this.variants.currentVariant) {
        var currentVariantEvt = { variant: this.variants.currentVariant };
        this._updateAddToCartBtn(currentVariantEvt);
        this._updateDelivery(currentVariantEvt);
        this._updatePrice(currentVariantEvt);
        this._updateSKU(currentVariantEvt);
        this._updateImages(currentVariantEvt);
      }
    },

    _updateAddToCartBtn: function(evt) {
      var variant = evt.variant;

      var addToCartEl = document.querySelector(this.selectors.addToCart);
      var addToCartTextEl = document.querySelector(this.selectors.addToCartText);

      /* PF ADDED THIS */

      if (variant) {
        // Keep the V6 amount current even before the US-only SDK finishes loading.
        var paypalEl = this.container.querySelector('.product-paypal-message');
        if (paypalEl) {
          paypalEl.setAttribute('amount', (variant.price / 100).toFixed(2));
          if (paypalEl.updatePayPalMessage) paypalEl.updatePayPalMessage();
        }

        var affirmEl = document.querySelector('.affirm-as-low-as');
        if (affirmEl) affirmEl.setAttribute('data-amount', variant.price);
        if (typeof affirm !== 'undefined' && affirm.ui && typeof affirm.ui.refresh === 'function') {
          // affirm.ui.refresh() can throw internally (eg. when third-party
          // cookies are blocked) -- that must never take down the rest of
          // this function (add-to-cart button state, etc).
          try {
            affirm.ui.refresh();
          } catch (err) {
            console.error('[theme.Product] affirm.ui.refresh() threw:', err);
          }
        }

        var klarnaEl = document.querySelector('klarna-placement');
        if (klarnaEl) klarnaEl.setAttribute('data-purchase-amount', variant.price);
        try {
          window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        } catch (err) {
          console.error('[theme.Product] KlarnaOnsiteService.push() threw:', err);
        }

        toggleDisplay(
          '#eduform',
          variant.title.includes('Education') || this.productSingleObject.title.includes('Education')
        );
        // Crossgrade can be in the product title or a variant title; check both, as for #eduform.
        toggleDisplay(
          '#presonus-crossgrade',
          variant.title.includes('Crossgrade') || this.productSingleObject.title.includes('Crossgrade')
        );
        toggleDisplay(
          '#steinberg-crossgrade',
          variant.title.includes('Crossgrade') || this.productSingleObject.title.includes('Crossgrade')
        );
        toggleDisplay('#audio-modeling-upgrade', variant.title === 'Upgrade from V2 to V3');
        /* END PF CODE */

        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          if (addToCartEl) {
            addToCartEl.classList.remove('btn--sold-out');
            addToCartEl.disabled = false;
          }
          if (addToCartTextEl) addToCartTextEl.innerHTML = theme.strings.addToCart;
        } else {
          // Variant is sold out, disable the submit button
          if (addToCartEl) {
            addToCartEl.disabled = true;
            addToCartEl.classList.add('btn--sold-out');
          }
          if (addToCartTextEl) addToCartTextEl.innerHTML = theme.strings.soldOut;
        }
      } else {
        if (addToCartEl) {
          addToCartEl.disabled = true;
          addToCartEl.classList.remove('btn--sold-out');
        }
        if (addToCartTextEl) addToCartTextEl.innerHTML = theme.strings.unavailable;
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;
      var priceEl = document.querySelector(this.selectors.productPrice);
      var comparePriceEl = document.querySelector(this.selectors.comparePrice);
      var newDiscountEls = document.querySelectorAll('.newDiscount');
      var onSale = Boolean(variant && variant.compare_at_price > variant.price);

      if (variant && priceEl) {
        // Keep the .price-money wrapper; only its contents change.
        var moneyEl = priceEl.querySelector('.price-money') || priceEl;
        moneyEl.innerHTML = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
      }

      // Same rounding and >10% threshold as snippets/product-info.liquid.
      var discountPercent = onSale
        ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
        : 0;
      newDiscountEls.forEach(function(el) {
        el.classList.toggle('hide', discountPercent <= 10);
        el.textContent = discountPercent > 10 ? discountPercent + '% ' + (el.dataset.suffix || 'off') : '';
      });

      if (comparePriceEl) {
        if (onSale) {
          comparePriceEl.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat);
        }
        comparePriceEl.classList.toggle('hide', !onSale);
        var rrpEl = comparePriceEl.parentElement.querySelector('.rrp');
        if (rrpEl) rrpEl.classList.toggle('hide', !onSale);
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      if (variant) {
        document.querySelectorAll(this.selectors.SKU).forEach(function(el) {
          el.innerHTML = variant.sku;
        });
      }
    },

    // On every variant change, not just SKU changes: variants can share a SKU
    // (or have none) and still differ in stock.
    _updateDelivery: function(evt) {
      var variant = evt.variant;

      if (variant) {
        var inventoryLevel = typeof inv_qty !== 'undefined' ? inv_qty[variant.id] : undefined;
        var manuallyEl = document.getElementById('manually');
        var instantDeliveryEls = document.querySelectorAll('.instant-delivery');

        if (inventoryLevel > 0) {
          if (manuallyEl) manuallyEl.style.display = 'none';
          instantDeliveryEls.forEach(function(el) { el.style.display = ''; });
        } else if (inventoryLevel < 1) {
          if (manuallyEl) manuallyEl.style.display = '';
          instantDeliveryEls.forEach(function(el) { el.style.display = 'none'; });
        }
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;

      if (variant && variant.featured_image) {
        // Already showing (server-rendered for the selected variant): keep its responsive srcset.
        var featuredImageEl = document.querySelector(this.selectors.productFeaturedImage);
        if (featuredImageEl && featuredImageEl.dataset.imageId === String(variant.featured_image.id)) return;

        // Same widths as snippets/product-images.liquid.
        this.switchProductImage(
          theme.sizedImageUrl(variant.featured_image.src, 1024),
          theme.sizedImageUrl(variant.featured_image.src, 2048),
          variant.featured_image.id,
          variant.featured_image.width,
          variant.featured_image.height
        );
        this.setActiveThumbnail();
      }
    },

    // width/height are the new image's original size; without them the srcset is dropped
    // (it describes the previous image) and the old dimensions stay.
    switchProductImage: function(image, largeImage, imageId, width, height) {
      var featuredImageEl = document.querySelector(this.selectors.productFeaturedImage);
      var imageWrapEl = document.querySelector(this.selectors.productImageWrap);
      if (featuredImageEl) {
        width = parseInt(width, 10);
        height = parseInt(height, 10);
        if (width && height) {
          var baseUrl = image.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
          var srcset = theme.productImageSrcsetWidths
            .filter(function(w) { return w < width; })
            .concat(width)
            .map(function(w) { return theme.sizedImageUrl(baseUrl, w) + ' ' + w + 'w'; })
            .join(', ');
          var slot = Math.min(width, theme.productImageMaxSlot);
          featuredImageEl.setAttribute('srcset', srcset);
          featuredImageEl.setAttribute('sizes', '(min-width: 881px) ' + slot + 'px, 90vw');
          featuredImageEl.setAttribute('width', width);
          featuredImageEl.setAttribute('height', height);
          featuredImageEl.style.setProperty('--main-img-max', slot + 'px');
          featuredImageEl.style.setProperty('--main-img-ratio', width / height);
        } else {
          featuredImageEl.removeAttribute('srcset');
        }
        featuredImageEl.setAttribute('src', image);
        featuredImageEl.dataset.imageId = imageId || '';
      }
      if (imageWrapEl) imageWrapEl.setAttribute('href', largeImage);
    },

    setActiveThumbnail: function(el) {
      var thumbsEl = document.querySelector(this.selectors.productThumbs);

      // If there is no element passed, find it by the current product image
      if (typeof el === 'undefined') {
        var featuredImageEl = document.querySelector(this.selectors.productFeaturedImage);
        var src = featuredImageEl ? featuredImageEl.getAttribute('src') : null;
        el = src ? document.querySelector('.product-thumbnail[href="' + src + '"]') : null;
      }

      // Set active thumbnail class
      if (thumbsEl) {
        thumbsEl.querySelectorAll('.product-thumbnail-item').forEach(function(item) {
          item.classList.remove('is-active');
        });
      }
      if (el && el.parentElement) {
        el.parentElement.classList.add('is-active');
      }

      // If the thumbnail strip scrolls (more than 2 thumbnails), bring the
      // newly active one into view.
      if (thumbsEl && thumbsEl.classList.contains('product-thumbnails--scroller') && el && el.parentElement) {
        el.parentElement.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    },

    _productZoomImage: function() {
      var featuredImageEl = document.querySelector(this.selectors.productFeaturedImage);
      if (!featuredImageEl) {
        return;
      }

      var self = this;
      var imageWrapEl = document.querySelector(this.selectors.productImageWrap);

      this._onImageWrapClickHandler = function(evt) {
        evt.preventDefault();
        // Empty src before loading new image to avoid awkward image swap
        var zoomImgEl = document.querySelector(self.selectors.productZoomImage);
        if (zoomImgEl) {
          zoomImgEl.setAttribute('src', '');
          zoomImgEl.setAttribute('src', evt.currentTarget.getAttribute('href'));
        }
      };

      if (imageWrapEl) {
        imageWrapEl.addEventListener('click', this._onImageWrapClickHandler);
      }

      this.ProductModal = new window.Modals(this.selectors.modal, 'product-modal');

      // Close modal if clicked, but not if the image is clicked
      if (this.ProductModal.modal) {
        this._onModalClickHandler = function(evt) {
          if (evt.target.nodeName !== 'IMG') {
            self.ProductModal.close();
          }
        };
        this.ProductModal.modal.addEventListener('click', this._onModalClickHandler);
      }
    },

    _productThumbSwitch: function() {
      var thumbsWrapperEl = document.querySelector(this.selectors.productThumbs);
      if (!thumbsWrapperEl) {
        return;
      }

      var self = this;
      this._onThumbClickHandler = function(evt) {
        evt.preventDefault();
        var link = evt.currentTarget;
        var sizedImageUrl = link.getAttribute('href');
        var largeImageUrl = link.getAttribute('data-zoom');
        self.setActiveThumbnail(link);
        self.switchProductImage(
          sizedImageUrl,
          largeImageUrl,
          link.dataset.imageId,
          link.dataset.width,
          link.dataset.height
        );
      };

      document.querySelectorAll(this.selectors.productThumbImages).forEach(function(el) {
        el.addEventListener('click', self._onThumbClickHandler);
      });
    },

    // Thumbnail strip: native scroll-snap plus arrow buttons (styles in product-new.css.liquid).
    _productThumbnailSlider: function() {
      var thumbsWrapperEl = document.querySelector(this.selectors.productThumbs);
      if (!thumbsWrapperEl) {
        return;
      }

      var thumbnailCount = thumbsWrapperEl.querySelectorAll(
        this.selectors.productThumbAllImages
      ).length;

      // Thumbnails are 20% wide (a third on phones, see product-new.css), so up to 5 (3) fit
      // without scrolling; no arrows needed.
      var thumbsPerView = window.matchMedia('(max-width: 750px)').matches ? 3 : 5;
      if (thumbnailCount > thumbsPerView) {
        thumbsWrapperEl.classList.add('product-thumbnails--scroller');
        var arrows = buildScrollArrows(thumbsWrapperEl, 'thumbnails');
        if (arrows) {
          this._onThumbsScrollHandler = arrows.onScroll;
        }
        this._productSwipeInit();

        // Bring the initially-active thumbnail into view (no smooth-scroll
        // animation on first load, same as the old slickGoTo(..., true)).
        var activeEl = thumbsWrapperEl.querySelector('.is-active');
        if (activeEl) {
          activeEl.scrollIntoView({ inline: 'nearest', block: 'nearest' });
        }
      }
    },

    // Available Bundles: fixed-width cards, so rely on buildScrollArrows' overflow check.
    _bundlesSlider: function() {
      var bundlesWrapperEl = document.querySelector('.product-bundles-wrap');
      if (!bundlesWrapperEl) {
        return;
      }

      var arrows = buildScrollArrows(bundlesWrapperEl, 'bundles');
      if (arrows) {
        this._onBundlesScrollHandler = arrows.onScroll;
      }
    },

    // Swiping left/right on the main product image steps to the
    // next/previous thumbnail (single-step, wraps around) -- distinct from
    // the arrow buttons above, which page the thumbnail strip itself.
    _productSwipeInit: function() {
      var featuredImageEl = document.querySelector(this.selectors.productFeaturedImage);
      if (!featuredImageEl) return;

      var self = this;
      var touchStartX = null;
      var touchStartY = null;
      var swipeThreshold = 30;

      this._onTouchStartHandler = function(evt) {
        var touch = evt.touches && evt.touches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      };

      this._onTouchEndHandler = function(evt) {
        if (touchStartX === null) return;
        var touch = evt.changedTouches && evt.changedTouches[0];
        if (!touch) return;

        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;

        // Only treat it as a swipe if it's clearly more horizontal than
        // vertical, so vertical page-scrolling isn't hijacked.
        if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) < Math.abs(deltaY)) {
          return;
        }

        if (deltaX < 0) {
          self._goToNextThumbnail();
        } else {
          self._goToPrevThumbnail();
        }
      };

      featuredImageEl.addEventListener('touchstart', this._onTouchStartHandler, { passive: true });
      featuredImageEl.addEventListener('touchend', this._onTouchEndHandler, { passive: true });
    },

    _goToNextThumbnail: function() {
      this._stepThumbnail(1);
    },

    _goToPrevThumbnail: function() {
      this._stepThumbnail(-1);
    },

    _stepThumbnail: function(direction) {
      var thumbsWrapperEl = document.querySelector(this.selectors.productThumbs);
      if (!thumbsWrapperEl) return;

      var items = Array.prototype.slice.call(thumbsWrapperEl.querySelectorAll('.product-thumbnail-item'));
      if (!items.length) return;

      var currentIndex = items.findIndex(function(item) {
        return item.classList.contains('is-active');
      });

      var nextIndex = currentIndex + direction;
      if (nextIndex < 0) nextIndex = items.length - 1;
      if (nextIndex >= items.length) nextIndex = 0;

      var nextLink = items[nextIndex].querySelector('.product-thumbnail');
      if (nextLink) {
        // Reuses the normal click handler (_onThumbClickHandler) so the
        // main image, active state, and scroll-into-view all update the
        // same way a real click would.
        nextLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    },

    onUnload: function() {
      var imageWrapEl = document.querySelector(this.selectors.productImageWrap);
      if (imageWrapEl && this._onImageWrapClickHandler) {
        imageWrapEl.removeEventListener('click', this._onImageWrapClickHandler);
      }

      if (this._onThumbClickHandler) {
        var self = this;
        document.querySelectorAll(this.selectors.productThumbImages).forEach(function(el) {
          el.removeEventListener('click', self._onThumbClickHandler);
        });
      }

      var thumbsEl = document.querySelector(this.selectors.productThumbs);
      if (thumbsEl && this._onThumbsScrollHandler) {
        thumbsEl.removeEventListener('scroll', this._onThumbsScrollHandler);
      }

      var bundlesEl = document.querySelector('.product-bundles-wrap');
      if (bundlesEl && this._onBundlesScrollHandler) {
        bundlesEl.removeEventListener('scroll', this._onBundlesScrollHandler);
      }

      var featuredImageEl = document.querySelector(this.selectors.productFeaturedImage);
      if (featuredImageEl) {
        if (this._onTouchStartHandler) featuredImageEl.removeEventListener('touchstart', this._onTouchStartHandler);
        if (this._onTouchEndHandler) featuredImageEl.removeEventListener('touchend', this._onTouchEndHandler);
      }

      if (this.ProductModal && this.ProductModal.modal && this._onModalClickHandler) {
        this.ProductModal.modal.removeEventListener('click', this._onModalClickHandler);
      }

      if (this.variants) {
        this.variants.unbind();
      }
    }
  });

  return Product;
})();
